export default "__VITE_ASSET__BR5$dM7y__"